import { render } from "./ClienteMainDashView.vue?vue&type=template&id=280c4af0"
import script from "./ClienteMainDashView.vue?vue&type=script&lang=js"
export * from "./ClienteMainDashView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__